// src/redux/slices/searchHistory.slice.js
import { createSlice } from '@reduxjs/toolkit'

const initialState = {}

const searchHistorySlice = createSlice({
  name: 'searchHistory',
  initialState,
  reducers: {
    incrementProviderSearch: (state, action) => {
      const id = action.payload
      state[id] = (state[id] || 0) + 1
    }
  }
})

export const { incrementProviderSearch } = searchHistorySlice.actions
export default searchHistorySlice.reducer
